import { render, staticRenderFns } from "./SetThanks.vue?vue&type=template&id=66cdb517&scoped=true"
import script from "./SetThanks.vue?vue&type=script&lang=js"
export * from "./SetThanks.vue?vue&type=script&lang=js"
import style0 from "./SetThanks.vue?vue&type=style&index=0&id=66cdb517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdb517",
  null
  
)

export default component.exports